// Убирает риску между числами до 19-08-17 после 19.08.17
export function ParseDate(date) {
    if (date) {
        return date.replace(/-/g, '.');
    } else {
        return ``
    }
}
// Убирает в конце секунды до 22:00:00 после 22:00
export function ParseTime(time) {
    if (time !== null) {
        return time.replace(/:\d+$/g, '');
    } else {
        return ``
    }
}

// Убирает в конце секунды и милисекунды до 17:00:26.538293Z после 17:00
export function ParseTimeMS(time) {
    if (time !== null) {
        return time.replace(/:[\d.\w]+$/g, '');
    } else {
        return ``
    }
}

export function EqualsDate(date_start, date_end) {
    if (date_start !== null && date_end !== null) {
        return date_start === date_end;
    } else {
        return false
    }
}

export function GetDateTime(date_time, mode) {
    if (mode === "DATE") {
        // до 2017-11-28T17:00:26.538293Z после 2017-11-28
        return ParseDate(date_time.replace(/T\S+/g, ''));
    } else if (mode === "TIME") {
        // до 2017-11-28T17:00:26.538293Z после 17:00:26.538293Z
        return ParseTimeMS(date_time.replace(/\S+T/g, ''));
    }
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/lib/DateTimeParse.js